
<template>
  <b-modal
    title="Update Program"
    header-bg-variant="success"
    header-text-variant="light"
    size="lg"
    :visible="showModal"
    centered
    @hidden="reset"
    >
    <template #modal-header-close>
      <h4>X</h4>
    </template>

     <b-row v-show="updateProgramPending">
      <h2  class="u-padding-bottom-20">Updating, please wait ...</h2>
      <pulse-loader :loading="updateProgramPending" color='#0F347B'></pulse-loader>
    </b-row>

    <b-row v-if="!updateProgramPending">
      <b-col sm='12' md='6'>
        <b-form>
        <div v-if="selectedProgramRec"><b>ID: </b>{{selectedProgramRec.id}}</div>

          <b-form-group label="Program Type" label-class='addpersonlabel' label-for="title">
            <b-form-select size="lg"
              v-validate="'required'"
              data-vv-name="title"
              data-vv-as="title"
              :options="programTypesByState" id='title' v-model='updatedTitle'>
            </b-form-select>
            <span v-show="inputValidationErrors.has('title')" class="text-info">{{ inputValidationErrors.first('title') }}</span>
          </b-form-group>

          <b-form-group v-if="updatedTitle === 'Other'" label="Other Program Type" label-class='addpersonlabel' label-for="title_otherText">
            <b-form-input size="lg"
              v-validate="'required'"
              data-vv-name="title_otherText"
              data-vv-as="title_otherText"
              id='title_otherText' v-model='updatedTitleOtherText'>
            </b-form-input>
            <span v-show="inputValidationErrors.has('title_otherText')" class="text-info">{{ inputValidationErrors.first('title_otherText') }}</span>
          </b-form-group>

          <b-alert
            :show="!uniqueProgramName"
            variant="warning"
            >
            <span>Please enter a unique program name.</span>
          </b-alert>

        </b-form>
      </b-col>
      <b-col sm='12' md='6'>
        <br>
        <b>Created At: </b>  {{ getCreatedAt() }}
        <div v-if="_.isObject(selectedProgramRec.createdBy)">
          <b> by: </b> {{ _.get(selectedProgramRec, 'createdBy.emailAddress', '') }}
        </div>
        <br>
        <b>Last Updated: </b>  {{ getLastUpdateDate() }}
        <div v-if="_.isObject(selectedProgramRec.updatedBy)">
          <b> by: </b> {{ _.get(selectedProgramRec, 'updatedBy.emailAddress', '') }}
        </div>
        <br>
      </b-col>
    </b-row>

    <b-alert
      fade
      :show="updateProgramFailure || _.isObject(updateProgramSuccess)"
      :variant="updateProgramFailure ? 'danger' : 'success'"
    >
      <span v-html="apiResponseMessage()"></span>
    </b-alert>

    <div slot="modal-footer" class="w-100">
      <b-button
        v-if="!disableDelete"
          type="button"
          variant="danger"
          size="sm"
          class="float-left"
          @click="deleteHandler"
      >
        <span class="button-text">Delete</span>
      </b-button>
      <!--
        <span v-else class="text-danger"> This is the primary organization for this user.  It cannot be removed.  </span>
      -->
      <b-button
          type="button"
          variant="primary"
          size="sm"
          class="float-right"
          @click="programHandler"
      >
        <span class="button-text">Update</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'update-program-modal',
  props: {
    organizationId: Number,
    selectedProgramRec: Object,
    orgPrograms: Array,
    showModal: Boolean,
    disableDelete: Boolean,
    orgState: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      user: 'getViewUser',
      updateProgramPending: 'getUpdateProgramPending',
      updateProgramFailure: 'getUpdateProgramFailure',
      updateProgramSuccess: 'getUpdateProgramSuccess',
      programTypes: 'getProgramTypes',
      programTypesLA: 'getProgramTypesLA'
    }),

    programTypesByState () {
      if (this.orgState === 'LA') {
        return this.programTypesLA
      }
      return this.programTypes
    }
  },
  data: function () {
    return {
      uniqueProgramName: true,
      updatedTitle: this.selectedProgramRec.title,
      updatedTitleOtherText: this.selectedProgramRec.title_otherText
    }
  },
  watch: {
    updateProgramSuccess: function (newValue) {
      if (this.showModal) {
        _.delay(this.reset, 1000)
      }
    },
    showModal (newValue) {
      if (newValue) {
        this.showModal = newValue
      }
    },
    selectedProgramRec (newValue) {
      if (newValue) {
        this.updatedTitle = newValue.title
        this.updatedTitleOtherText = newValue.title_otherText
      }
    }
  },
  methods: {
    getCreatedAt () {
      const selectedProgramRec = this.selectedProgramRec
      if (selectedProgramRec.createdAt && selectedProgramRec.createdAt.includes('T')) {
        return this.$utils.formatDate(selectedProgramRec.createdAt)
      } else if (selectedProgramRec.createdAt) {
        return this.$utils.unixToHuman(selectedProgramRec.createdAt / 1000)
      }
    },
    getLastUpdateDate: function () {
      const selectedProgramRec = this.selectedProgramRec
      if (selectedProgramRec.updatedAt && selectedProgramRec.updatedAt.includes('T')) {
        return this.$utils.formatDate(selectedProgramRec.updatedAt)
      } else if (selectedProgramRec.updatedAt) {
        return this.$utils.unixToHuman(selectedProgramRec.updatedAt / 1000)
      }
    },
    reset: function () {
      this.$emit('update:showModal', false)
      this.clearForm()
    },
    programHandler () {
      this.uniqueProgramName = true
      const updatedTitle = this.updatedTitle !== 'Other' ? this.updatedTitle : this.updatedTitleOtherText
      let titleLC = updatedTitle.toLowerCase()
      var orgTitles = this.orgPrograms.map((o) => o.title)
      const currentTitleIndex = orgTitles.indexOf(this.selectedProgramRec.title)
      orgTitles.splice(currentTitleIndex, 1)
      orgTitles.forEach((orgTitle) => {
        if (orgTitle.toLowerCase() === titleLC) {
          this.uniqueProgramName = false
        }
      })

      if (this.uniqueProgramName && this.selectedProgramRec) {
        this.$store.dispatch('updateProgram', {
          id: this.selectedProgramRec.id,
          data: {
            title: this.updatedTitle,
            title_otherText: this.updatedTitle === 'Other' ? this.updatedTitleOtherText : ''
          }
        })
      }
    },
    deleteHandler () {
      if (this.selectedProgramRec) {
        this.$store.dispatch('deleteProgam', {
          id: this.selectedProgramRec.id
        })
      }
    },
    apiResponseMessage () {
      let message = ''
      if (this.updateProgramSuccess) {
        message = 'Success!'

        this.$store.dispatch('getOrganizationView', {
          id: this.organizationId
        })
      }
      if (this.updateProgramFailure) {
        message = this.$utils.errorToHtml(this.updateProgramFailure)
      }

      return '<p>' + message + '</p>'
    },
    clearForm () {
      this.$store.commit('RESET_UPDATE_PROGRAM')
    }
  },
  beforeDestroy () {
    this.reset()
  },
  created () {
    this.$store.dispatch('getProgramRecords', {})
    this.uniqueProgramName = true
    this.updatedTitle = this.selectedProgramRec.title
  }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/Admin/UpdateProgramModal.vue